import { render } from "./primary.vue?vue&type=template&id=1a40b628&scoped=true"
import script from "./primary.vue?vue&type=script&lang=js"
export * from "./primary.vue?vue&type=script&lang=js"

import "./primary.vue?vue&type=style&index=0&id=1a40b628&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40b628"]])

export default __exports__